import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17.978 10.57 7.718 4.485a1.652 1.652 0 0 0-1.671-.016c-.526.3-.839.84-.839 1.445v12.17c0 .605.313 1.146.839 1.445a1.65 1.65 0 0 0 1.671-.016l10.261-6.085c.509-.303.814-.837.814-1.43s-.304-1.127-.815-1.43z"
}), 'PlayFilled');